// src/com/help/HelpDialog.js
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import DraggableViewer from '../common/DraggableViewer';
import { useReactiveVar } from '@apollo/client';
import { currentMenuRepo } from '../../model/CvoModel';


export default function HelpDialog({
    open,
    onClose,
    helpTopic,
}) {
    const menuInfo = useReactiveVar(currentMenuRepo);
    return(
        <DraggableViewer
            open={open}
            onClose={onClose}
            title={menuInfo ? menuInfo.menuName : '도움말'}
            fullWidth={true}
            startIcon={<InfoIcon fontSize="large" />}
        >
            {helpTopic && helpTopic.component ? React.createElement(helpTopic.component) : null}
        </DraggableViewer>
    );
}